import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector) // Automatically detect language
  .use(initReactI18next)  // Pass i18n to react-i18next
  .init({
    fallbackLng: 'en', // Default language
    debug: true,       // Enable debug logs during development
    
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    resources: {
        en: { translation: require('./locales/en/translation.json') },
        fr: { translation: require('./locales/fr/translation.json') },
        es: { translation: require('./locales/es/translation.json') },
        sh: { translation: require('./locales/sh/translation.json') },
        nd: { translation: require('./locales/nd/translation.json') }, // Add Ndebele
        de: { translation: require('./locales/de/translation.json') }  // Add German
        },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['cookie', 'localStorage'], // Cache user language preferences
    },
  });

export default i18n;
